import React from 'react';
import Typography from '@digital-hig/typography';
import PropTypes from 'prop-types';
import Select from '@digital-hig/select';
import { useTranslation } from 'react-i18next';
import SortingRootElement from './style';
import { SORTBY } from '../../../common/constants';

const Sorting = ({ handleSortChange, sortValue }) => {
  const { t } = useTranslation();
  const sortOptions = Object.values(SORTBY).map((value) => ({
    children: t(value),
    value: t(value),
  }));

  return (
    <SortingRootElement>
      <div className="filter-sort">
        <Typography>
          {t('Sort by')}
          :
        </Typography>
      </div>
      <Select
        defaultValue={t(sortValue)}
        onChange={(e) => {
          const originalValue = Object.values(SORTBY).find((val) => t(val) === e.target.value);
          if (originalValue) {
            handleSortChange(originalValue);
          }
        }}
        options={sortOptions}
        value={t(sortValue)}
        id="select-quiet"
        variant="filled"
        className="sorting-dropdown"
        data-wat-val={sortValue}
        data-wat-loc="Sort by"
      />
    </SortingRootElement>
  );
};

Sorting.propTypes = {
  handleSortChange: PropTypes.func.isRequired,
  sortValue: PropTypes.string.isRequired,
};

export default Sorting;
